<div *transloco="let t">

    <div class="event-card py-16"
         [ngClass]="{'grid-layout-card min-height': currentLayout === CalendarViewType.GRID}">

      <ng-template [ngTemplateOutlet]="currentLayout === CalendarViewType.LIST ? listItem : gridItem"/>

    </div>

  <ng-template #listItem>
    <div class="d-flex justify-content-start gap-3 flex-grow-1 px-16">
      <ng-template [ngTemplateOutlet]="eventImage"></ng-template>

      <div class="d-flex flex-column flex-grow-1">
        <ng-template [ngTemplateOutlet]="eventName"></ng-template>

        <div class="d-flex flex-column gap-2">
          <ng-template [ngTemplateOutlet]="raceName"></ng-template>
          <ng-template [ngTemplateOutlet]="tags"></ng-template>
        </div>
        <div class="d-flex justify-content-between align-items-end flex-grow-1">
          <ng-template [ngTemplateOutlet]="eventDateLocation"></ng-template>
          <ng-template [ngTemplateOutlet]="actionButtons"></ng-template>
        </div>

      </div>

    </div>
  </ng-template>

  <ng-template #gridItem>
    <div class="d-flex justify-content-start gap-3 flex-grow-1 px-16">
      <ng-template [ngTemplateOutlet]="eventImage"></ng-template>

      <div class="d-flex flex-column flex-grow-1">
        <ng-template [ngTemplateOutlet]="eventName"></ng-template>
        <ng-template [ngTemplateOutlet]="raceName"></ng-template>
      </div>
    </div>

    <div class="px-16">
      <div class="d-flex flex-column gap-2 mt-2">
        <ng-template [ngTemplateOutlet]="tags"></ng-template>
        <ng-template [ngTemplateOutlet]="eventDateLocation"></ng-template>
      </div>
      @if (type === UserEventGridItemType.UPCOMING) {
        <div class="d-flex justify-content-end mt-2">
          <ng-template [ngTemplateOutlet]="actionButtons"></ng-template>
        </div>
      }
    </div>

    <!-- RESULTS -->
    @if (type === UserEventGridItemType.FINISHED) {
      <div class="divider-horizontal mt-1"></div>
      <div class="stats-grid px-16">
        <div class="stat">
          <p class="fw-300 mb-1">{{  t('competitor.table.time') }}</p>
          <p class="fs-16">
            {{ competitorResult?.competitorResultsDetail | resultsTotalTime:raceItem?.raceSettings?.measurementType:raceItem?.raceSettings?.measurementPrecisionType}}
          </p>
        </div>

        <div class="stat">
          <p class="fw-300 mb-1">{{  t('competitor.table.tempo') }}</p>
          <p class="fs-16">
            {{competitorResult?.competitorResultsDetail | competitorTempo:raceItem}}
          </p>
        </div>

        <div class="stat">
          <p class="fw-300 mb-1">{{  t('competitor.table.absolute.rank') }}</p>
          <p class="fs-16">
            {{( competitorResult?.categoryRank || competitorResult?.sexRank || competitorResult?.absoluteRank) ?
            '#' + (competitorResult?.categoryRank || competitorResult?.sexRank || competitorResult?.absoluteRank) : competitorResult?.status }}
          </p>
        </div>
      </div>
      <div class="divider-horizontal mb-3"></div>
      <div class="px-16">
        <ng-template [ngTemplateOutlet]="actionButtons"></ng-template>
      </div>
    }
  </ng-template>

  <ng-template #eventName>
    <p class="fs-18 trim-text-third-line fw-500">
      <app-language-output [hrLabel]="eventItem?.name" [srLabel]="eventItem?.nameSr"
                           [enLabel]="eventItem?.nameEng" [itLabel]="eventItem?.nameIta"
                           [bsLabel]="eventItem?.nameBs" [siLabel]="eventItem?.nameSlo"
                           [defaultLanguage]="eventItem?.defaultLanguage" [languages]="languages"/>
    </p>
  </ng-template>

  <ng-template #raceName>
    <p class="fs-16 fw-400 color-slate-600 trim-text">
      <app-language-output [hrLabel]="raceItem?.name" [srLabel]="raceItem?.nameSr"
                           [enLabel]="raceItem?.nameEng" [itLabel]="raceItem?.nameIta"
                           [bsLabel]="raceItem?.nameBs" [siLabel]="raceItem?.nameSlo"
                           [languages]="languages"/>
    </p>

  </ng-template>

  <ng-template #eventImage>
    <div>
      <img src="{{raceItem?.imageMedium || eventItem?.imageMedium || eventItem?.imageIcon || ''}}"
           alt="Logo"
           class="event-logo"
           [sportOne]="raceItem?.sport ?? eventItem?.sportOne"
           [sportTwo]="eventItem?.sportTwo"
           appImageFallback/>
    </div>
  </ng-template>


  <ng-template #actionButtons>
    <div class="d-flex justify-content-end button-wrapper">
      @if (showLeftActionButton) {
        <app-button-alt [buttonColor]="'transparent'" [textColor]="'var(--teal-500)'"  [buttonHeight]="'35px'"
                        [text]="t(leftButtonKey)" [borderColor]="'transparent'"
                        (onClickCallback)="onLeftButtonClick()" [isFullWidth]="false" [fontSize]="'14px'"></app-button-alt>
      }
      @if (showRightActionButton) {
        <app-button-alt [buttonHeight]="'35px'"
                        [text]="t(rightButtonKey)"
                        (onClickCallback)="onRightButtonClick()" [isFullWidth]="false" [fontSize]="'14px'"></app-button-alt>

      }
    </div>
  </ng-template>


  <ng-template #eventDateLocation>
    <div class="d-flex fs-16" style="grid-template-columns: auto 1fr; column-gap: 0.1rem; align-items: center;">
      <div class="d-flex align-items-center color-slate-600">
        <app-event-date-display [start]="raceItem?.raceStart" [end]="raceItem?.raceEnd" [showIcon]="false"/>
      </div>
      @if (type === UserEventGridItemType.UPCOMING) {
        <i class="bi bi-dot"></i>
        <div class="d-flex align-items-center">
          <app-location-display [city]="eventItem?.city" [countryId]="eventItem?.country" [showIcon]="false"/>
        </div>
      }
    </div>
  </ng-template>

  <ng-template #tags>
    <div class="d-flex justify-content-start">
      <div class="tag me-2">
        {{raceItem?.length | raceLengthFormat: translocoService.getActiveLang() | uppercase}}
      </div>

      @if (raceItem?.sport) {
        <div class="tag me-2">
          <p> {{t("app.common.sports." + raceItem?.sport) | uppercase}} </p>
        </div>
      }

      @if (type === UserEventGridItemType.UPCOMING) {
        <div class="tag text-uppercase" [class.green]="paymentCompleted" [class.red]="!paymentCompleted">
          <p> {{ paymentCompleted ? t('event.item.payment.completed') : t('account.statements.amountStatus.3') }}</p>
        </div>
      }
    </div>
  </ng-template>
</div>
